// extracted by mini-css-extract-plugin
export default {"root":"ChatQuotedMessage_root__MaOXB"};